// Modal popup functionality for session-based display
import { Modal } from 'bootstrap';

(function() {
    document.addEventListener('DOMContentLoaded', function() {
        const pageModal = document.querySelector('.page-modal');

        if (!pageModal) return;

        // Use the modal snippet ID for tracking (not the page-specific modal ID)
        const modalSnippetId = pageModal.dataset.modalId;
        const sessionKey = 'modal_shown_' + modalSnippetId;

        // Check if this specific modal has already been shown this session
        if (!sessionStorage.getItem(sessionKey)) {
            // Show modal after a short delay
            setTimeout(function() {
                const modal = new Modal(pageModal);
                modal.show();

                // Mark this modal as shown for this session
                sessionStorage.setItem(sessionKey, 'true');
            }, 1000); // 1 second delay
        }
    });
})();
